import React, { useEffect, useRef, useState } from "react";
import "./Workshops.css";

export default function Workshops() {
  const refs = useRef([]);
  const mouseRef = useRef({ x: 0, y: 0 });
  const [mouse, setMouse] = useState({ x: 0, y: 0 });

  // 🔥 SCROLL ANIMATION
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    refs.current.forEach(el => el && observer.observe(el));

    return () => observer.disconnect();
  }, []);

  // 🔥 SMOOTH MOUSE FOLLOW (premium hissi)
  useEffect(() => {
    const handleMove = (e) => {
      mouseRef.current = { x: e.clientX, y: e.clientY };
    };

    const animate = () => {
      setMouse(prev => ({
        x: prev.x + (mouseRef.current.x - prev.x) * 0.08,
        y: prev.y + (mouseRef.current.y - prev.y) * 0.08
      }));
      requestAnimationFrame(animate);
    };

    window.addEventListener("mousemove", handleMove);
    animate();

    return () => window.removeEventListener("mousemove", handleMove);
  }, []);

  const addRef = el => {
    if (el && !refs.current.includes(el)) refs.current.push(el);
  };

  return (
    <div
      className="hx-container"
      style={{
        "--x": `${mouse.x}px`,
        "--y": `${mouse.y}px`
      }}
    >

      {/* HERO */}
      <section className="hx-section">
        <h1>ATÖLYELER</h1>
        <p>KOKUNUZU BİR RİTÜELE DÖNÜŞTÜRÜN</p>

        <video
          src="/videos/video11.mp4"
          autoPlay
          muted
          loop
          playsInline
          className="hx-video"
        />
      </section>

      {/* SECTION 1 */}
      <section className="hx-section fade-section" ref={addRef}>
        <h2>DENEYİM</h2>

        <video
          src="/videos/videoo.mp4"
          autoPlay
          muted
          loop
          playsInline
          className="hx-video"
        />

        <p>
          Koku yalnızca bir duyudan fazlasıdır. Anıları uyandırır ve iz bırakır.
        </p>
      </section>

      {/* SECTION 2 */}
      <section className="hx-section fade-section" ref={addRef}>
        <h2>İMZA KOKUNUZ</h2>

        <img
          src="/images/foto11.jpeg"
          alt="Atölye"
          className="hx-image"
        />

        <p>
          Bu deneyimin sonunda ortaya çıkan koku yalnızca size ait olur.
        </p>
      </section>

    </div>
  );
}